import { render, staticRenderFns } from "./goal-indicator.vue?vue&type=template&id=2287a514&"
import script from "./goal-indicator.vue?vue&type=script&lang=js&"
export * from "./goal-indicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports